import { render, staticRenderFns } from "./voicetospeach.vue?vue&type=template&id=3ced40be&"
import script from "./voicetospeach.vue?vue&type=script&lang=js&"
export * from "./voicetospeach.vue?vue&type=script&lang=js&"
import style0 from "./voicetospeach.vue?vue&type=style&index=0&lang=css&"
import style1 from "vue-svg-map/dist/index.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports